// UKG PRO (MAIN & MERGE)
import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";
import {
  GetAdditionalTableFields,
  toggleValueInList
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";

export const UKGProSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  let { tables } = config;
  // additional tables
  const additionalFields = GetAdditionalTableFields(config.source);
  let additionalFieldOptions = additionalFields.map(table => {
    return { value: table, label: table };
  });
  // selected tables
  let selectedTables = tables ?? [];
  let selectedFieldOptions = selectedTables.map(table => {
    return { value: table, label: table };
  });

  const isMergeSource = importType === "merge";

  const onTableChange = e => {
    let option = e.value;
    const selectedList = toggleValueInList(selectedTables, option.value);
    onChange({ ...config, tables: selectedList });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={isMergeSource}
      showAdditionalFields
      selectedAdditionalFields={selectedFieldOptions}
      additionalFieldOptions={additionalFieldOptions}
      onAdditionalFieldChange={onTableChange}
      showLoadHeaders={isMergeSource}
      importType={importType}
      ATSType={isMergeSource ? enumATSModes.notATS : undefined}
    />
  );
};
